// 生产手动修改七牛 version
export const version = "21";
/**
 * 判断非空字符串
 * @param str 字符串
 * @returns boolean
 */
export const isNotEmptyString = (str: any): boolean => {
  return str !== undefined && str !== null && str !== "";
};

// 去掉前后空格
export const trim = (str: string): string => {
  return str.replace(/(^\s*)|(\s*$)/g, "");
};

// input框禁止输入空格
export const getValueFromEvent = (e: any): any => {
  return trim(e.target.value);
};

// 排除一些url
export const canVisit = (pathname: string, excludePaths: string[]): boolean => {
  for (let i = 0; i < excludePaths.length; i++) {
    if (pathname.includes(excludePaths[i])) {
      return false;
    }
  }
  return true;
};

/**
 * 判断浏览器版本
 * @returns supporter 版本  supporterVs 版本号
 */
export const browerVerson = (): any => {
  const ua = global.navigator.userAgent.toLowerCase();
  console.log(ua);
  const testVs = (regexp: any): any =>
    String(ua.match(regexp))
      .replace(/[^0-9|_.]/gi, "")
      .replace(/_/gi, ".");
  const testUa = (regexp: any): any => regexp.test(ua);

  let engine = "unknow";
  let supporter = "unknow";
  if (Boolean(testUa(/applewebkit/gi)) && Boolean(testUa(/safari/gi))) {
    engine = "webkit"; // webkit内核
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (testUa(/edge/gi)) {
      supporter = "edge"; // edge浏览器
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    } else if (testUa(/opr/gi)) {
      supporter = "opera"; // opera浏览器
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    } else if (testUa(/chrome/gi)) {
      supporter = "chrome"; // chrome浏览器
    } else {
      supporter = "safari"; // safari浏览器
    }
  } else if (Boolean(testUa(/gecko/gi)) && Boolean(testUa(/firefox/gi))) {
    engine = "gecko"; // gecko内核
    supporter = "firefox"; // firefox浏览器
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  } else if (testUa(/presto/gi)) {
    engine = "presto"; // presto内核
    supporter = "opera"; // opera浏览器
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  } else if (testUa(/trident|compatible|msie/gi)) {
    engine = "trident"; // trident内核
    supporter = "iexplore"; // iexplore浏览器
  }
  // 内核版本
  let engineVs = "unknow";

  if (engine === "webkit") {
    engineVs = testVs(/applewebkit\/[\d.]+/gi);
  } else if (engine === "gecko") {
    engineVs = testVs(/gecko\/[\d.]+/gi);
  } else if (engine === "presto") {
    engineVs = testVs(/presto\/[\d.]+/gi);
  } else if (engine === "trident") {
    engineVs = testVs(/trident\/[\d.]+/gi);
  }
  // console.log(engineVs)
  // 载体版本
  let supporterVs = "unknow";
  if (supporter === "chrome") {
    supporterVs = testVs(/chrome\/[\d.]+/gi);
  } else if (supporter === "safari") {
    supporterVs = testVs(/version\/[\d.]+/gi);
  } else if (supporter === "firefox") {
    supporterVs = testVs(/firefox\/[\d.]+/gi);
  } else if (supporter === "opera") {
    supporterVs = testVs(/opr\/[\d.]+/gi);
  } else if (supporter === "iexplore") {
    supporterVs = testVs(/(msie [\d.]+)|(rv:[\d.]+)/gi);
  } else if (supporter === "edge") {
    supporterVs = testVs(/edge\/[\d.]+/gi);
  }
  return { supporter, supporterVs, engineVs };
};

/**
 * 判断浏览器是否支持antd5.0的:where选择器
 * 兼容性：
   Chrome 88及以上
   Edge 88及以上
   Safari 14及以上
   Firefox 78及以上
   Opera 74及以上
   IE 不支持
 * @returns
 */
export const isSupportCss = (): any => {
  let { supporter, supporterVs } = browerVerson();
  supporterVs = supporterVs.split(".")[0];
  let isSupport = true;
  switch (supporter) {
    case "chrome":
      isSupport = supporterVs >= 88;
      break;
    case "edge":
      isSupport = supporterVs >= 88;
      break;
    case "safari":
      isSupport = supporterVs >= 14;
      break;
    case "firefox":
      isSupport = supporterVs >= 78;
      break;
    case "opera":
      isSupport = supporterVs >= 74;
      break;
    case "ie":
      isSupport = false;
      break;
    default:
  }
  return isSupport;
};

// 将数组奇偶项转为对象的方法
export const pairArrayToObj = (arr: any[]): any => {
  const obj: any = {};
  for (let i = 0; i < arr.length; i += 2) {
    obj[arr[i]] = arr[i + 1];
  }
  return obj;
};

// 匹配数组中的关键字
export const containsAny = (input: string, keywords: string[]): boolean => {
  const regex = new RegExp(keywords.map(keyword => `\\b${keyword}\\b`).join("|"), "i");
  return regex.test(input);
};

// // 跳转语服平台
// export const goGolingoPlat = (type: number, language: string) => {
//   let url = "";

//   const locale = language ?? "zh"; // 暂时不生效 因为语服平台现在没开启国际化 开启的时候需要修改预付系统的跳转sso的方法
//   if (type === PlatType.DEMAND) {
//     // 需求方
//     url = `${Url.customerUrl()}?locale=${locale}`;
//     // 埋点
//     track(clickEvent.demand_webclick);
//   } else {
//     // 服务商
//     url = `${Url.providerUrl()}?locale=${locale}`;
//     // 埋点
//     track(clickEvent.provision_webclick);
//   }
//   window.location.href = url;
// };

export const isMobile = () => {
  // 用户代理检测（包含平板）
  const ua = navigator?.userAgent?.toLowerCase();
  const uaMobile = /mobi|android|iphone|ipod|blackberry|iemobile|opera mini|ipad|tablet/i.test(ua);

  // 屏幕特性检测
  // const screenSmall = window?.innerWidth <= 768;

  // 现代媒体查询检测
  // const mediaMobile = window?.matchMedia?.("(max-width: 768px), (pointer: coarse)").matches;

  // 触摸特性检测
  const touchSupport = "ontouchstart" in window || navigator?.maxTouchPoints > 0;

  // // 设备像素比检测（手机通常 ≥ 1.5）
  // const highDPI = window?.devicePixelRatio >= 1.5;

  // let platformMobile = false;
  // // 平台信息检测
  // // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  // if (navigator && navigator?.platform) {
  //   const platform = navigator.platform.toLowerCase();
  //   platformMobile = /android|iphone|ipad|ipod|blackberry|iemobile/i.test(platform);
  // }

  // 综合判断（任意条件命中即返回true）
  return uaMobile || touchSupport;
};
